import React from "react";

// components

export default function HeaderStats() {
  return (
    <>
      {/* Header */}
      <div
        className="relative md:pt-32 pb-32 pt-12"
        style={{
          backgroundImage:
            "url(" + require("assets/img/authbg.jpg").default + ")",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "noRepeat"
        }}
      >
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            <div className="flex flex-wrap"></div>
          </div>
        </div>
      </div>
    </>
  );
}
